import React from 'react';
import _ from 'lodash';
import Link from 'next/link';

type LinkListItem = {
  title: string;
  url: string;
  as?: string;
  children?: LinkListItem[];
};

type LinkListProps = {
  items: LinkListItem[];
};

const LinkList = ({ items }: LinkListProps) => (
  <ul>
    {_.map(items, (item) => (
      <li key={`link-list-${_.kebabCase(item.title)}`}>
        <Link href={item.url} as={item.as}>
          {item.title}
        </Link>

        {item.children && <LinkList items={item.children} />}
      </li>
    ))}
  </ul>
);

export default LinkList;
